import { BrowserRouter, Route, Routes } from "react-router-dom";
import './App.css'
import RouteScrollToTop from "./helper/RouteScrollToTop";
import { AdminProfile, CarParts, ContactUs, ContentMangement, Customers, DashboardPage, Dealerships, DocumentsVerify, ErrorPage, ForgotPasswordPage, Inquiries, ServiceAppointments, SignInPage, SignUpPage, TestDrives, UnAuthorized, Users, Vehicles, Promotions, Complaints } from "./pages";
import { AboutUs, AppSettings, Faqs, MobileAppMenus, PrivacyPolicy, Testing, Toc, } from "./pages/sub-pages";
import ProtectedLayout from "./auth/ProtectedLayout";
import UsersGridLayer from "./pages/Test";
import ProtectedRoute from "./auth/ProtectedRoutes";
import RolesManagement from "./pages/RolesManagement";
import ProtectedPages from "./auth/ProtectedPages";

function App() {

  const protectedRoutes = [
    // --- Main Protected Pages ---
    { path: "/", element: <DashboardPage />, pageId: 1, index: true },
    { path: "/vehicles", element: <Vehicles />, pageId: 2 },
    { path: "/cars-parts", element: <CarParts />, pageId: 3 },
    { path: "/dealers", element: <Dealerships />, pageId: 4 },
    { path: "/users", element: <Users />, pageId: 5 },
    { path: "/test-drives", element: <TestDrives />, pageId: 6 },
    { path: "/service-appointments", element: <ServiceAppointments />, pageId: 7 },
    { path: "/contact-us-queries", element: <ContactUs />, pageId: 8 },
    { path: "/app-settings", element: <ContentMangement />, pageId: 9 },
    { path: "/roles-management", element: <RolesManagement />, pageId: 10 },
    { path: "/promotions", element: <Promotions />, pageId: 11 },
    { path: "/customers", element: <Customers />, pageId: 12 },
    { path: "/documents-verification", element: <DocumentsVerify />, pageId: 13 },
    { path: "/inquiries", element: <Inquiries />, pageId: 14 },
    { path: "/complaints", element: <Complaints />, pageId: 16 },

    // --- Not Protected Pages ---
    { path: "/view-profile", element: <AdminProfile /> },
    { path: "/faqs", element: <Faqs /> },
    { path: "/about-us", element: <AboutUs /> },
    { path: "/terms-condition", element: <Toc /> },
    { path: "/mobile-app-settings", element: <AppSettings /> },
    { path: "/privacy-policy", element: <PrivacyPolicy /> },
    { path: "/testing", element: <Testing /> },
    { path: "/mobile-menus", element: <MobileAppMenus/>},
    { path: "/test", element: <UsersGridLayer /> },
  ];



  return (
    <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <RouteScrollToTop />
      <Routes>

        {/* Public Routes */}
        <Route path="/sign-in" element={<SignInPage />} />
        <Route path="/sign-up" element={<SignUpPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />

        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<ProtectedLayout />}>

            {protectedRoutes.map(({ path, element, pageId, index }, i) => (
              <Route
                key={i}
                path={path}
                index={index}
                element={pageId
                  ? <ProtectedPages pageId={pageId}>{element}</ProtectedPages>
                  : element}
              />
            ))}

          </Route>
        </Route>

        {/* 404 Fallback */}
        <Route path="*" element={<ErrorPage />} />
        <Route path="/unauthorized" element={<UnAuthorized />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;